/**
 * Custom events Intelligems (window.igEvents).
 * @see https://docs.intelligems.io/analytics/custom-events/custom-javascript-events
 *
 * Events à enregistrer dans l'Events Manager :
 * - productMediaGalleryArrowClick_${productTitle}
 * - productMediaGallerySlideChange_${productTitle}
 *
 * Index 1-based. Les properties sont aussi envoyées
 * (stockées par Intelligems, pas encore filtrables en analytics).
 */

const MAX_EVENT_NAME_LENGTH = 100;

/**
 * @param {string} value
 * @returns {string}
 */
const sanitizeEventPart = (value) =>
  String(value || '')
    .replace(/[,'']/g, '')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * @param {string} name
 * @param {Record<string, unknown>} [properties]
 */
export const trackIgEvent = (name, properties) => {
  const event = sanitizeEventPart(name).slice(0, MAX_EVENT_NAME_LENGTH);
  if (!event) return;

  window.igEvents = window.igEvents || [];

  /** @type {{ event: string, properties?: Record<string, unknown> }} */
  const payload = { event };
  if (properties && Object.keys(properties).length > 0) {
    payload.properties = properties;
  }

  window.igEvents.push(payload);
};
